import React from "react";
import { Table, Button, Flex, Tag } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import EditableCell from "../editableCell/EditableCell"; 

const TableCultureAttributes = (props) => {

    const columns = [
        {
            title: "Id",
            dataIndex: "cat_id",
            key: "cat_id",
            align: "center",
        },
        {
            title: "Atributo Cultural",
            dataIndex: "cat_attribute",
            key: "cat_attribute",
            editable: true,
        },
        {
            title: "Tipo",
            dataIndex: "cat_type",
            key: "cat_type",
            align: "center",
            render: (text) => {
                let color = 'blue';
                if (text === 'Palancas culturales') color = 'green';
                if (text === 'Compromiso') color = 'orange';
                return <Tag color={color}>{text}</Tag>;
            }
        },
        {
            title: '',
            dataIndex: 'cat_actions',
            key: 'cat_actions',
            align: "center",
            fixed: "right",
            width: 60,
            render: (text, row, index) => {
                return <Flex gap="small" wrap>
                    <Button onClick={() => setCultureAttributeValuesToSee(row)} style={{ backgroundColor: "#293790", color: "white" }} icon={<EyeOutlined />} size={"large"} title='Ver atributo cultural' />
                </Flex>
            }
        }
    ];

    const setCultureAttributeValuesToSee = (cat) => {
        props.setCultureAttributeValuesToSee(cat)
    }

    return (
        <Table
            className="custom-green-table"
            size="small"
            dataSource={props.data}
            columns={columns}
            pagination={{ pageSize: 10, position: ["bottomRight"] }}
            scroll={{ x: "max-content" }}
            components={{ body: { cell: EditableCell } }}
        />
    );
};

export default TableCultureAttributes;